module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0111.jpg?v=4179157f";